import React, { useState } from 'react';
import { Facebook, ChevronDown } from 'lucide-react';
interface LegalAccordionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}
function LegalAccordion({
  title,
  isOpen,
  onToggle,
  children
}: LegalAccordionProps) {
  return <div className="rounded-md overflow-hidden" style={{
    backgroundColor: 'rgba(255,255,255,0.04)'
  }} data-id="element-35">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-2 px-3 py-2 text-left text-sm font-medium hover:bg-white/5 transition-colors focus:outline-none" style={{
      color: '#A8E6CF'
    }} aria-expanded={isOpen} data-id="element-36">
        <span data-id="element-37">{title}</span>
        <ChevronDown className={`w-4 h-4 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} style={{
        color: '#A8E6CF'
      }} data-id="element-38" />
      </button>
      <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-39">
        <div className="overflow-hidden" data-id="element-40">
          <div className="px-3 pb-3 pt-1 text-xs leading-relaxed space-y-3" style={{
          color: '#D1D5DB'
        }} data-id="element-41">
            {children}
          </div>
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [openItem, setOpenItem] = useState<'privacy' | 'terms' | null>(null);
  const toggle = (item: 'privacy' | 'terms') => () => setOpenItem(openItem === item ? null : item);
  return <footer className="bg-text text-white py-8" data-id="element-42">
      <div className="max-w-6xl mx-auto px-4" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-start" data-id="element-44">
          {/* Left — Logo */}
          <div data-id="element-45">
            <img src="https://cdn.magicpatterns.com/uploads/t2kwCs67Yc7emwGGMrjmR2/Marca_con_fondo_transparente-removebg-preview.png" alt="El Código del Bienestar" style={{
            width: '220px',
            height: 'auto',
            filter: 'brightness(0) invert(1)',
            backgroundColor: 'transparent'
          }} className="block border-0 outline-none max-w-full bg-transparent" data-id="element-46" />
          </div>

          {/* Center — Legal (accordion) */}
          <div data-id="element-47">
            <h3 className="font-bold text-base mb-2 text-white" data-id="element-48">Legal</h3>
            <div className="space-y-2" data-id="element-49">
              <LegalAccordion title="Política de Privacidad" isOpen={openItem === 'privacy'} onToggle={toggle('privacy')} data-id="element-50">
                <p className="italic" style={{
                color: '#9CA3AF'
              }} data-id="element-51">
                  Última actualización: 1 de enero de 2026
                </p>
                <div data-id="element-52">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-53">
                    1. Información que recopilamos
                  </p>
                  <p data-id="element-54">
                    Recopilamos la información mínima necesaria para procesar tu
                    compra y entregarte el e-book: nombre, correo electrónico y
                    datos de pago (procesados de forma segura por proveedores
                    certificados).
                  </p>
                </div>
                <div data-id="element-55">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-56">
                    2. Uso de la información
                  </p>
                  <p data-id="element-57">
                    Usamos tus datos para enviarte el enlace de descarga,
                    brindar soporte y, ocasionalmente, contenido relacionado con
                    bienestar. Puedes darte de baja en cualquier momento.
                  </p>
                </div>
                <div data-id="element-58">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-59">
                    3. Protección de datos
                  </p>
                  <p data-id="element-60">
                    Tus datos se almacenan en servidores seguros con cifrado
                    estándar. Nunca vendemos, alquilamos ni compartimos tu
                    información con terceros con fines comerciales.
                  </p>
                </div>
                <div data-id="element-61">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-62">
                    4. Cookies
                  </p>
                  <p data-id="element-63">
                    Utilizamos cookies esenciales y cookies analíticas anónimas
                    para mejorar la experiencia. No usamos cookies de publicidad
                    invasivas.
                  </p>
                </div>
                <div data-id="element-64">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-65">
                    5. Tus derechos
                  </p>
                  <p data-id="element-66">
                    Tienes derecho a acceder, rectificar o eliminar tus datos en
                    cualquier momento. Escríbenos a
                    contacto@elcodigodelbienestar.com.
                  </p>
                </div>
                <div data-id="element-67">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-68">
                    6. Contacto
                  </p>
                  <p data-id="element-69">
                    Para preguntas sobre esta política, contáctanos a través de
                    nuestro correo oficial. Respondemos en máximo 72 horas
                    hábiles.
                  </p>
                </div>
              </LegalAccordion>

              <LegalAccordion title="Términos y Condiciones" isOpen={openItem === 'terms'} onToggle={toggle('terms')} data-id="element-70">
                <p className="italic" style={{
                color: '#9CA3AF'
              }} data-id="element-71">
                  Última actualización: 1 de enero de 2026
                </p>
                <div data-id="element-72">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-73">
                    1. Aceptación de los términos
                  </p>
                  <p data-id="element-74">
                    Al adquirir El Código del Sueño Profundo, aceptas estos
                    términos y condiciones. Si no estás de acuerdo, te pedimos
                    que no realices la compra.
                  </p>
                </div>
                <div data-id="element-75">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-76">
                    2. Naturaleza del producto
                  </p>
                  <p data-id="element-77">
                    El producto es un e-book digital en PDF entregado por
                    descarga inmediata tras el pago. No es un producto físico.
                  </p>
                </div>
                <div data-id="element-78">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-79">
                    3. Pago y entrega
                  </p>
                  <p data-id="element-80">
                    El pago se procesa de forma segura. Una vez confirmado,
                    recibirás un correo con el enlace de descarga en minutos. Si
                    no lo recibes, revisa tu spam o contáctanos.
                  </p>
                </div>
                <div data-id="element-81">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-82">
                    4. Política de reembolso
                  </p>
                  <p data-id="element-83">
                    Por ser un producto digital de descarga inmediata, los
                    reembolsos se evalúan caso por caso. Escríbenos dentro de
                    los 7 días posteriores a la compra.
                  </p>
                </div>
                <div data-id="element-84">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-85">
                    5. Propiedad intelectual
                  </p>
                  <p data-id="element-86">
                    Todo el contenido es propiedad de El Código del Bienestar.
                    Está prohibida su reproducción, distribución o reventa sin
                    autorización escrita.
                  </p>
                </div>
                <div data-id="element-87">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-88">
                    6. Aviso médico
                  </p>
                  <p data-id="element-89">
                    ⚕️ El contenido es informativo y educativo. No reemplaza el
                    consejo, diagnóstico ni tratamiento médico profesional.
                  </p>
                </div>
                <div data-id="element-90">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-91">
                    7. Limitación de responsabilidad
                  </p>
                  <p data-id="element-92">
                    Los resultados pueden variar según cada persona. No
                    garantizamos resultados específicos. El usuario es
                    responsable de aplicar las recomendaciones con criterio.
                  </p>
                </div>
                <div data-id="element-93">
                  <p className="font-semibold" style={{
                  color: '#A8E6CF'
                }} data-id="element-94">
                    8. Contacto
                  </p>
                  <p data-id="element-95">
                    Para consultas legales o sobre tu compra, escríbenos a
                    contacto@elcodigodelbienestar.com.
                  </p>
                </div>
              </LegalAccordion>
            </div>
          </div>

          {/* Right — Síguenos */}
          <div data-id="element-96">
            <h3 className="font-bold text-base mb-2 text-white" data-id="element-97">Síguenos</h3>
            <a href="https://www.facebook.com/profile.php?id=61589346766845" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm transition-colors" style={{
            color: '#93C5FD'
          }} data-id="element-98">
              <Facebook className="w-4 h-4" style={{
              color: '#93C5FD'
            }} data-id="element-99" />
              <span data-id="element-100">@ElCódigoDelBienestar</span>
            </a>
          </div>
        </div>

        <div className="mt-6 border-y font-serif italic text-center" style={{
        color: '#A8E6CF',
        borderColor: 'rgba(168, 230, 207, 0.3)',
        fontSize: '18px',
        padding: '20px 0'
      }} data-id="element-101">
          Tu cuerpo tiene un código.
          <br data-id="element-102" />
          Aquí te ayudamos a descifrarlo.
        </div>

        <div className="pt-4 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-accent" data-id="element-103">
          <p data-id="element-104">© 2026 El Código del Bienestar.</p>
          <p data-id="element-105">⚕️ Contenido informativo. No reemplaza consejo médico.</p>
        </div>
      </div>
    </footer>;
}